import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { ShopFrontService } from "../../../services";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { routes } from "../../../constants/routes";
import { Form, Modal } from "react-bootstrap";
import { handleConsoleError } from "../../../utils/common-methods";

const ShopFrontModel = {
  id: "",
  productTitle: "",
  productDescription: "",
  image: "",
  imageUrl: "",
  price: null,
  status: false,
};

export default function CreateShopFront() {
  const navigate = useNavigate();
  const { id } = useParams();
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();
  const [imagePreview, setImagePreview] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [shopfrontData, setShopFrontData] = useState({ ...ShopFrontModel });
  const [imageError, setImageError] = useState("");
  const [file, setFile] = useState(null);

  useEffect(() => {
    getShopFrontById();
    register("status");
  }, []);

  const getShopFrontById = async () => {
    try {
      const res = (id && (await ShopFrontService.getShopFrontById(id))) || [];
      const pitchMappedData = { ...ShopFrontModel, ...res?.data };
      reset(pitchMappedData);
      setShopFrontData(pitchMappedData);

      if (pitchMappedData.imageUrl) {
        setImagePreview(pitchMappedData.imageUrl);
      }
    } catch (error) {
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const onSubmit = async (data) => {
    try {
      let response = null;
      const formData = new FormData();

      if (id) {
        formData.append("Id", id || "");
      }
      formData.append("ProductTitle", data?.productTitle);
      formData.append("ProductDescription", data?.productDescription);
      formData.append("Price", data?.price);
      formData.append("Status", true);

      if (!imagePreview && (!data.Image || !data.Image[0])) {
        setImageError("Image is required.");
        return;
      } else {
        setImageError("");
      }

      if (data.Image && data.Image[0]) {
        const file = data.Image[0];
        const validTypes = ["image/jpeg", "image/png"];
        if (!validTypes.includes(file.type)) {
          setImageError("Invalid image format. Only JPG and PNG are allowed.");
          return;
        }
        formData.append("Image", file);
      }
      if (file) {
        formData.append("Image", file);
      }

      response = await ShopFrontService.AddupdateShopFront(formData);

      if (response?.isSuccess) {
        toast.success(response?.message);
        navigate(routes.EVENT_SHOPFRONT_LIST);
      } else {
        toast.error(response?.message);
      }
    } catch (error) {
      const message=handleConsoleError(error)
      toast.error(error?.message || message);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    const validTypes = ["image/jpeg", "image/png"];

    if (file && validTypes.includes(file.type)) {
      setFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader?.result);
        setImageError("");
      };
      reader.readAsDataURL(file);
    } else {
      setImageError("Invalid image format. Only JPG and PNG are allowed.");
      setFile(null);
    }
  };

  const handleIsStatus = (event) => {
    const newStatus = event.target.checked;
    setShopFrontData({
      ...shopfrontData,
      status: newStatus,
    });
    setValue("status", newStatus);
  };

  return (
    <div className="container mt-5">
      <div className="card p-4 shadow-sm">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-3">
            <label>Product Title </label>
            <input
              type="text"
              className="form-control"
              {...register("productTitle", {
                required: "Product Title is required",
              })}
            />
            {errors.productTitle && (
              <p className="text-danger">{errors.productTitle?.message}</p>
            )}
          </div>
          <div className="mb-3">
            <label>Description </label>
            <input
              type="text"
              className="form-control"
              {...register("productDescription", {
                required: "Description is required",
              })}
            />
            {errors.productDescription && (
              <p className="text-danger">{errors.productDescription?.message}</p>
            )}
          </div>
          <div className="mb-3">
            <label>Price(£) </label>
            <input
              type="text"
              className="form-control"
              {...register("price", {
                required: "Price is required",
                pattern: {
                  value: /^\d*(\.\d{0,2})?$/,
                  message:
                    "Please enter a valid numbers with up to 2 decimal points greater than zero.",
                },
              })}
            />
            {errors.price && (
              <p className="text-danger">{errors.price?.message}</p>
            )}
          </div>

          <div className="mb-3">
            <label>Image</label>
            <div className="d-flex align-items-center">
              <input
                type="file"
                className="form-control me-2"
                accept="image/jpeg, image/png"
                {...register("Image")}
                onChange={handleImageChange}
              />
            </div>
            {imageError && <p className="text-danger mt-1">{imageError}</p>}{" "}
          </div>

          {imagePreview && (
            <div
              onClick={() => setIsModalVisible(true)}
              style={{ cursor: "pointer" }}
              className="mb-3"
            >
              <img
                src={imagePreview}
                alt="Preview"
                className="img-fluid"
                style={{ maxWidth: "200px" }}
              />
            </div>
          )}

          {/* <div className="custom-check mb-3">
            <label>Status</label>
            <Form.Check
              type="checkbox"
              checked={shopfrontData.status}
              onChange={handleIsStatus}
            />
          </div> */}

          <div className="d-flex gap-2 mt-3">
            <button type="submit" className="btn btn-primary">
              Submit
            </button>
          </div>
        </form>
      </div>

      <Modal show={isModalVisible} onHide={() => setIsModalVisible(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Image Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {imagePreview && (
            <img
              src={imagePreview}
              alt="Uploaded Preview"
              className="img-fluid rounded"
            />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}
